export const setChartData = (state, chartData, chartType) => {
  const key = Object.keys(chartData)[0]
  state.chartData[key] = chartData[key]
}
